function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { createEpicMiddleware } from "redux-observable";
import logger from "redux-logger";
import rootEpic from "../epics/rootEpic";
import rootReducer from "../reducers";
import services from "../services";
import routerMiddleware from "./middlewares/routerMiddleware";
var ref, ref1;
var epicMiddleware = createEpicMiddleware({
    dependencies: services
});
var middlewares = [
    thunk,
    routerMiddleware,
    epicMiddleware
];
if (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.host) === null || ref1 === void 0 ? void 0 : ref1.includes("localhost")) {
    middlewares.push(logger);
}
var store = createStore(rootReducer, applyMiddleware.apply(void 0, _toConsumableArray(middlewares)));
epicMiddleware.run(rootEpic);
export default store;

//# sourceMappingURL=index.js.map